<template>
  <van-popup
    class="cropper-popup-compress"
    v-model="popup"
    position="bottom"
    :style="{ height: '100%' }"
  >
    <div class="cropper-content">
      <VueCropper
        ref="cropper"
        :img="option.img"
        :outputSize="option.outputSize"
        :outputType="option.outputType"
        :info="option.info"
        :full="option.full"
        :canMove="option.canMove"
        :canMoveBox="option.canMoveBox"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :original="option.original"
        :autoCrop="option.autoCrop"
        :fixed="option.fixed"
        :fixedNumber="option.fixedNumber"
        :centerBox="option.centerBox"
        :infoTrue="option.infoTrue"
        :fixedBox="option.fixedBox"
      >
      </VueCropper>
      <div class="crop-btns">
        <div @click="close">取消</div>
        <img
          src="../../assets/images/mine/rotate-clockwise-90.png"
          alt=""
          @click="rotate(1)"
        />
        <img
          src="../../assets/images/mine/rotate-anticlockwise-90.png"
          @click="rotate(0)"
          alt=""
        />
        <div @click="getImageData">完成</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import VueCropper from "vue-cropper";
export default {
  components: {
    VueCropper
  },
  props: {
    img: {
      type: String,
      default: ""
    },
    popup: {
      type: Boolean,
      default: false
    },
    fixed:{
      type: Boolean,
      default: true
    },
    fixedNumber: {
      type: Array,
      default: () => {
        return [1, 1];
      }
    },
    filename: {
      type: String,
      default: ""
    }
  },
  watch: {
    img(v) {
      this.option.img = v;
    },
    fixed: {
      immediate: true,
      handler: function (v) {
        this.option.fixed = v;
      }
    },
    fixedNumber: {
      immediate: true,
      handler: function (v) {
        this.option.fixedNumber = v;
      }
    }
  },
  data() {
    return {
      compress: false,
      option: {
        img: "",
        outputSize: 0.2, // 质量
        outputType: "jepg",
        info: true,
        autoCropWidth: 160,
        autoCropHeight: 160,
        canScale: true,
        autoCrop: true,
        fixedBox: false,
        fixed: true,
        fixedNumber: [1, 1],
        full: false,
        canMove: true,
        canMoveBox: true,
        original: false,
        centerBox: true,
        infoTrue: true
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    rotate(type) {
      type ? this.$refs.cropper.rotateRight() : this.$refs.cropper.rotateLeft();
    },
    getImageData() {
      const base64toFile = (dataurl) => {
        let arr = dataurl.split(",");
        let mime = arr[0].match(/:(.*?);/)[1];
        let suffix = mime.split("/")[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let filename = this.filename;
        if (!filename) {
          filename = `${suffix}_image_${Math.random().toString(32).slice(-8)}`;
        }

        return new File([u8arr], `${filename}.${suffix}`, {
          type: mime
        });
      };
      this.$refs.cropper.getCropData((data) => {
        const file = base64toFile(data);
        const src = data;
        this.close();
        this.$emit("getImageData", file, src);
      });
    }
  }
};
</script>

<style lang="scss">
.cropper-popup-compress {
  background-color: #0003;
  .cropper-content {
    width: 100%;
    height: 100%;
    .crop-btns {
      display: flex;
      position: absolute;
      left: 0;
      bottom: 0;
      justify-content: space-between;
      align-items: center;
      height: 48px;
      background: #0006;
      border-top: 1px solid #999;
      width: 100%;
      div {
        height: 100%;
        width: 80px;
        color: #fff;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
